import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isAdminRole } from 'app/modules/microservicio/utils/rol-admin';
import { UserService } from 'app/shared/services/user.service';

/**
 * Deja entrar solo a un admin, con la misma lista de roles que el menú y la API. Corre después de
 * `AuthGuard`, que ya cargó el usuario: si no se conoce, no entra, igual que el menú oculta esas
 * entradas mientras no llega.
 */
export const AdminRoleGuard: CanActivateFn = () => {
    if (isAdminRole(inject(UserService).user?.role)) {
        return true;
    }

    return inject(Router).parseUrl('home');
};
